module.exports = __webpack_public_path__ + "img/icon-saveposter@2x.a96f6732.png";